module.exports = __webpack_public_path__ + "img/student-account.9f8f2d6.svg";